export default __webpack_public_path__ + "static/media/lastP.dc27be20.jpg";